<div id="wrapper" class="mat-typography">
  <div id="circle"><mat-icon>close</mat-icon></div>
  <div id="right">
    <b i18n="@@failureModalHeader">We are sorry</b>
    <span>
      @switch (data.errorCode) {
        @case ('TAG_IS_IN_USE') {
          <ng-container i18n="@@tagIsInUse">The Badge is currently in use.</ng-container>
        }
        @case ('TAG_NOT_FOUND') {
          <ng-container i18n="@@tagNotFound">The Badge was not found.</ng-container>
        }
        @case ('PATIENT_NOT_FOUND') {
          <ng-container i18n="@@patientNotFound"
            >There is no patient associated to this Badge.</ng-container
          >
        }
        @case ('APP_MISCONFIGURATION') {
          <ng-container i18n="@@appMisconfiguration"
            >The application is not properly configured. Please contact your
            administrator.</ng-container
          >
        }
        @default {
          <ng-container i18n="@@errorUnknown">Unknown error</ng-container>
        }
      }
    </span>
  </div>
</div>
